import Component from '../core/Component'
import support from '../utils/BrowserSupport'
import scrollToElement from '../services/Viewport/scrollToElement'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class Accordion extends Component {

    constructor(element) {
        super(element, {
            scrollTo: false
        })

        this.ref = {
            items: [],
            toggles: [],
            contents: []
        }
    }

    prepare() {
        this.ref.toggles.forEach(toggle => toggle.addEventListener('click', ::this.handleToggleClick))
        this.ref.contents.forEach(content => content.addEventListener(support.transitionEnd, ::this.handleContentTransitionEnd))

        this.ref.items.forEach((item, index) => this.close(index, true))
    }

    handleToggleClick(event) {
        event.preventDefault()

        const index = this.ref.toggles.indexOf(event.currentTarget)

        this.toggle(index)
    }

    handleContentTransitionEnd(event) {
        const content = event.target
        const index = this.ref.contents.indexOf(content)
        const item = this.ref.items[index]

        if (this.options.scrollTo && item.classList.contains(STATES.ACTIVE)) {
            const box = item.getBoundingClientRect()
            if (box.top < 80 || box.top > 80 && window.innerHeight - box.bottom < 0) {
                scrollToElement(item, {
                    offset: 80
                })
            }
        }
    }

    toggle(itemIndex) {
        const item = this.ref.items[itemIndex]

        if (item.classList.contains(STATES.ACTIVE)) {
            this.close(itemIndex)
        } else {
            this.open(itemIndex)
        }
    }

    open(itemIndex) {
        const item = this.ref.items[itemIndex]
        const content = this.ref.contents[itemIndex]
        item.classList.add(STATES.ACTIVE)
        content.style.height = `${content.scrollHeight}px`

        this.ref.items.forEach((item, index) => {
            if (index !== itemIndex) {
                this.close(index)
            }
        })
    }

    close(itemIndex, force = false) {
        if (force || this.ref.items[itemIndex].classList.contains(STATES.ACTIVE)) {
            this.ref.items[itemIndex].classList.remove(STATES.ACTIVE)
            this.ref.contents[itemIndex].style.height = '0px'
        }
    }

}